module.exports = __webpack_public_path__ + "static/media/4.8a42f298.png";